// @ngInject
function IntrastatApiService(ResourcesService) {

    var endpoint = 'intrastats';

    return {
        getIntrastats: ResourcesService.apiFactory.get(endpoint),
        getIntrastat: ResourcesService.apiFactory.get(endpoint),
        saveIntrastat: ResourcesService.apiFactory.save(endpoint,'Intrastat'),
        deleteIntrastat: ResourcesService.apiFactory.delete(endpoint,'Intrastat')
    };


}

angular.module('intrastat.api', [])
  .factory('IntrastatApiService', IntrastatApiService);
